import { render, staticRenderFns } from "./UitschrijvenForm.vue?vue&type=template&id=a283accc&scoped=true"
import script from "./UitschrijvenForm.vue?vue&type=script&lang=js"
export * from "./UitschrijvenForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a283accc",
  null
  
)

export default component.exports